import "./LoginLoader.css";

export function LoginLoader({ status }) {
    return (
        <div className="login-loader-overlay">

                <div className={`loader-circle ${status}`}>

                    {status === "loading" && (
                        <>
                            {[...Array(8)].map((_, i) => (
                                <span
                                    key={i}
                                    className="dot"
                                    style={{ "--i": i }}
                                ></span>
                            ))}
                        </>
                    )}

                    {status === "success" && (
                        <svg className="checkmark" viewBox="0 0 52 52">
                            <circle className="check-circle" cx="26" cy="26" r="24" />
                            <path
                                className="check-path"
                                d="M14 27 L22 35 L38 18"
                            />
                        </svg>
                    )}

                    {status === "error" && (
                        <svg className="crossmark" viewBox="0 0 52 52">
                            <circle className="cross-circle" cx="26" cy="26" r="24" />
                            <path
                                className="cross-path"
                                d="M18 18 L34 34 M34 18 L18 34"
                            />
                        </svg>
                    )}

                </div>

                <h3>
                    {status === "loading" && "Logging you in..."}
                    {status === "success" && "Welcome Back!"}
                    {status === "error" && "Login Failed"}
                </h3>

                <p>
                    {status === "loading" && "Verifying your credentials"}
                    {status === "success" && "Redirecting..."}
                    {status === "error" && "Incorrect email or password"}
                </p>

            </div>
    );
}